import React, { useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';

import { GeoLocationProvider } from './contexts/geoLocationContext';
import { init, saveAuthToken } from './services/core';

import DesktopFlightSearch from './containers/DesktopFlightSearch';
import HomeMobileFlightSearch from './containers/HomeMobileFlightSearch';
import MobileFlightSearch from './containers/MobileFlightSearch';
import InfoModal from './components/InfoModal';

import {
  SearchProvider,
  useWindowSize,
  SearchContext,
  useSearch,
} from './hooks';

import i18nConfig from './i18n';

const App = () => {
  const [hasInitializedCore, setHasInitializedCore] = useState(false);

  const { width } = useWindowSize();
  function isDesktopSize() {
    return width > 1120;
  }

  async function initializeCore() {
    const sessionToken = localStorage.getItem('session-token');

    await saveAuthToken(sessionToken);

    const result = await init();
    setHasInitializedCore(result.success);

    if (!result.success) {
      // eslint-disable-next-line no-console
      console.error('Error initializing core');
    }
  }

  useEffect(() => {
    initializeCore();
    const urlParams = new URLSearchParams(window.location.search);
    const newPageQueryParam = urlParams.get('novo-resultado-voos');
    if (newPageQueryParam === 'true') {
      sessionStorage.setItem('novo-resultado-voos', 'true');
    }
  }, []);

  if (!hasInitializedCore) {
    return <div />;
  }

  return (
    <GeoLocationProvider>
      <SearchProvider>
        <I18nextProvider i18n={i18nConfig}>
          {isDesktopSize() ? (
            <DesktopFlightSearch />
          ) : (
            <HomeMobileFlightSearch />
          )}
          <InfoModal isMobile={isDesktopSize()} />
        </I18nextProvider>
      </SearchProvider>
    </GeoLocationProvider>
  );
};

export default App;

// Since this file is marked as the main file, we must export these from here
export {
  InfoModal,
  SearchContext,
  SearchProvider,
  GeoLocationProvider,
  DesktopFlightSearch,
  MobileFlightSearch,
  useSearch,
};
